import React from "react";
import { useTranslation } from "react-i18next";

const WEBSITE_BASE_URL = "https://www.verdictia.com";

const LEGAL_LINKS = {
    fr: [
        { key: "privacy", path: "/legal/confidentialite/index.html" },
        { key: "terms", path: "/legal/cgu/index.html" },
        { key: "security", path: "/legal/confidentialite/index.html#securite" },
    ],
    en: [
        { key: "privacy", path: "/en/legal/privacy/index.html" },
        { key: "terms", path: "/en/legal/terms/index.html" },
        { key: "security", path: "/en/legal/privacy/index.html#security" },
    ],
};

export default function LegalFooter() {
    const { t, i18n } = useTranslation("navigation");
    const language = i18n.language?.startsWith("fr") ? "fr" : "en";
    const links = LEGAL_LINKS[language] || LEGAL_LINKS.en;

    return (
        <footer className="app-legal-footer" aria-label={t("footer.ariaLabel")}>
            <span className="app-legal-footer__copyright">{t("footer.copyright")}</span>
            <nav className="app-legal-footer__links">
                {links.map((link) => (
                    <a
                        key={link.key}
                        href={`${WEBSITE_BASE_URL}${link.path}`}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {t(`footer.links.${link.key}`)}
                    </a>
                ))}
            </nav>
        </footer>
    );
}
